import { useEffect, useState } from "react";
import { X } from "lucide-react";

/**
 * Dismissible wrapper for admin/coach banners.
 * The dismissal is remembered in localStorage under `banner:<id>` so it
 * persists across reloads (until the underlying condition changes AND the
 * caller passes a different `id` — e.g. include the TBD count in the id).
 */
export function DismissibleBanner({ id, children, className = "", testId }) {
  const key = `banner-dismissed:${id}`;
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(key) === "1"; } catch { return false; }
  });
  useEffect(() => {
    try { setHidden(localStorage.getItem(key) === "1"); } catch {}
  }, [key]);
  if (hidden) return null;
  return (
    <div className={`relative ${className}`} data-testid={testId}>
      {children}
      <button
        type="button"
        onClick={() => { try { localStorage.setItem(key, "1"); } catch {} setHidden(true); }}
        aria-label="Hide banner"
        title="Hide this banner"
        data-testid={testId ? `${testId}-dismiss` : "banner-dismiss"}
        className="absolute top-2 right-2 p-1 rounded hover:bg-white/10 text-current opacity-70 hover:opacity-100 transition-opacity"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}

/** Global helper: clear every "banner-dismissed:*" flag from localStorage so
 * an admin (or a "Show hidden banners" button) can bring them all back. */
export function restoreAllBanners() {
  try {
    const toClear = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith("banner-dismissed:")) toClear.push(k);
    }
    toClear.forEach(k => localStorage.removeItem(k));
    return toClear.length;
  } catch { return 0; }
}
